module.exports = __webpack_public_path__ + "/images/testimonial-3.a12a209.png";